import { render, staticRenderFns } from "./VerticalNavMenuHeader.vue?vue&type=template&id=47caa603&scoped=true&"
import script from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuHeader.vue?vue&type=style&index=0&id=47caa603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47caa603",
  null
  
)

export default component.exports